import get from 'transmute/get';
import { MESSAGE_FEEDBACK_REQUEST } from '../constants/attachmentTypes';
import { getAttachments } from './getAttachments';
export const hasFeedbackRequestAttachment = message => getAttachments(message).some(attachment => get('@type', attachment) === MESSAGE_FEEDBACK_REQUEST);